import MessagesPage from "@/components/MessagesPage";

export default function PortalMessages() {
  return (
    <MessagesPage
      accent="blue"
      eyebrow="Clinic · Messages"
      title="Talk to your Nodera concierge"
      audienceHint="Threaded conversations with the Nodera operations team — vendor escalations, programs, billing questions."
    />
  );
}
